import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { ButtonChipItem } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledFilterDivider = styled(Flex)`
    width: 1px;
    height: 32px;
    background-color: ${colorsPalettes.carbon[200]};
`;

export const StyledButtonChipItem = styled(ButtonChipItem)`
    ${SWReactIcons} {
        width: 16px;
        height: 16px;
        margin-left: 8px;
        margin-right: 0;
    }
`;
